import { useEffect, useState } from "react";
import { YStack, Text, Spinner } from "tamagui";
import { RiErrorWarningLine } from "react-icons/ri";

import { colors } from "@styles/colors";

import { resolveThreeDsReturnPath } from "@utils/payThreeDsReturn";

/**
 * /pay/3ds-result：信用卡 3D 驗證完 TapPay 帶回的落地頁。只負責導回這張單的付款連結頁，
 * 付款結果由那頁輪詢（後端收到 TapPay 通知或對帳後才確定）。
 */
const ThreeDsResult = () => {
  const [lost, setLost] = useState(false);

  useEffect(() => {
    const path = resolveThreeDsReturnPath(window.location.search);
    if (path) {
      window.location.replace(path);
      return;
    }
    setLost(true);
  }, []);

  return (
    <YStack height="100dvh" width="100vw" ai="center" jc="center" gap="$3" px="$6" background={colors.bg}>
      {lost ? (
        <>
          <RiErrorWarningLine size={40} color={colors.hint} />
          <Text fontSize={15} fontWeight="700" color={colors.text} ta="center">
            驗證完成，請回到付款頁查看結果
          </Text>
          <Text fontSize={12} color={colors.hint} ta="center">
            重新掃描配送員的付款碼，或打開剛才的付款連結。不會重複扣款。
          </Text>
        </>
      ) : (
        <>
          <Spinner size="large" color={colors.primary} />
          <Text fontSize={13} color={colors.sub}>
            正在確認付款結果…
          </Text>
        </>
      )}
    </YStack>
  );
};

export default ThreeDsResult;
